module.exports = __webpack_public_path__ + "static/img/learning-level1.e6b4393e.png";